const isNumeric = (value: string) => !isNaN(+value);

export default isNumeric;
